import type { NumberOption, StringOption } from "cortex/ui/src/ui/table/types";

export type AlertPriority = "info" | "warning" | "critical";

export interface Alert {
  account_id: number;
  creation_date: string;
  description?: string | null;
  id: number;
  min_occurrence: number;
  name: string;
  notification_only: boolean;
  num_devices?: number;
  priority?: string | null;
  severity_levels?: number[];
  source_ids?: number[];
  target_devices?: Record<string, TargetDevice>;
  target_events: string[];
  time_range: number;
  user_id: number;
  user_ids: number[];
}

export enum FormAction {
  CREATE = "create",
  EDIT = "edit",
  NONE = "none",
}

export type FormErrors = Partial<Record<keyof FormValues, string>>;

export type FormValues = {
  createResolvableIncident: boolean;
  description?: string;
  emailAddresses: ReadonlyArray<number>;
  eventNames: ReadonlyArray<string>;
  frequency: number;
  id?: number;
  name: string;
  priorities: ReadonlyArray<number>;
  priority?: AlertPriority;
  sources: ReadonlyArray<string | number>;
  targetDevices: ReadonlyArray<string>;
  threshold: number;
};

export enum DrawerType {
  CREATE = "create",
  EDIT = "edit",
  NONE = "none",
}

export type TargetDevice = {
  id: number;
  name: string;
  type: string;
  is_deleted: boolean;
};

export const defaultFormValues: FormValues = {
  createResolvableIncident: false,
  emailAddresses: [],
  eventNames: [],
  frequency: 5,
  name: "",
  priorities: [],
  sources: [],
  targetDevices: [],
  threshold: 10,
};

export const PRIORITY_OPTIONS: NumberOption[] = [
  { label: "Information", value: 0 },
  { label: "Warning", value: 1 },
  { label: "Critical", value: 2 },
];

export const ALERT_PRIORITY_OPTIONS: StringOption[] = [
  { label: "Information", value: "info" },
  { label: "Warning", value: "warning" },
  { label: "Critical", value: "critical" },
];
